import { createGlobalStyle } from 'styled-components'
import Karla from '../fonts/Karla-Regular.woff2'
import Gochi from '../fonts/GochiHand-Regular.woff2'
import Syne from '../fonts/Syne-Regular.woff2'

const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: ${({ theme }) => theme.fonts.primary};
    src: url(${Karla}) format('woff2');
  }

  @font-face {
    font-family: ${({ theme }) => theme.fonts.title.lineOne};
    src: url(${Gochi}) format('woff2');
  }

  @font-face {
    font-family: ${({ theme }) => theme.fonts.title.lineTwo};
    src: url(${Syne}) format('woff2');
  }

  :root {
    color-scheme: light dark;
  }

  * {
    box-sizing: border-box;
  }

  body {
    position: relative;
    min-height: 100vh;
    overflow-x: hidden;
    background: ${({ theme }) => theme.colors.gradient.background};
    color: ${({ theme }) => theme.colors.palette.secondary};
    font-family: ${({ theme }) => theme.fonts.primary}, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 16px;
    line-height: 1.5;
    margin: 0;
  }

  body::before,
  body::after {
    content: '';
    position: fixed;
    border-radius: 999px;
    pointer-events: none;
    z-index: -1;
    filter: blur(42px);
    animation: drift 18s ease-in-out infinite alternate;
  }

  body::before {
    width: 34vw;
    height: 34vw;
    max-width: 460px;
    max-height: 460px;
    top: -10vh;
    right: -8vw;
    background: ${({ theme }) => theme.colors.gradient.spotlight};
  }

  body::after {
    width: 30vw;
    height: 30vw;
    max-width: 400px;
    max-height: 400px;
    bottom: 8vh;
    left: -10vw;
    background: ${({ theme }) => theme.colors.gradient.spotlight};
    opacity: 0.7;
    animation-duration: 24s;
    animation-direction: alternate-reverse;
  }

  ::selection {
    background: ${({ theme }) => theme.colors.palette.accent};
    color: ${({ theme }) => theme.colors.palette.primary};
  }

  #root {
    display: grid;
    grid-template-areas:
      'header'
      'content';
    grid-template-rows: ${({ theme }) => theme.sizes.header} 1fr;

    @media (max-width: ${({ theme }) => theme.screen.small}) {
      grid-template-rows: ${({ theme }) => theme.sizes.smallHeader} 1fr;
    }
  }

  @keyframes drift {
    from {
      transform: translate3d(0, 0, 0) scale(1);
    }

    to {
      transform: translate3d(-3%, 2%, 0) scale(1.08);
    }
  }
`

export default GlobalStyles
